import React, { useEffect, useState, useMemo } from 'react';
import { ConfigProvider } from 'antd';
import { useTranslation } from 'react-i18next';
import enUS from 'antd/locale/en_US';
import arEG from 'antd/locale/ar_EG';

const LocaleProvider = ({ children }) => {
    const { i18n } = useTranslation();
    const [direction, setDirection] = useState('ltr');
    const [currentLanguage, setCurrentLanguage] = useState(i18n.language);

    useEffect(() => {
        // Set initial direction
        const currentDir = ['ar', 'ku'].includes(i18n.language) ? 'rtl' : 'ltr';
        setDirection(currentDir);
        setCurrentLanguage(i18n.language);
        document.documentElement.setAttribute('dir', currentDir);
        document.documentElement.setAttribute('lang', i18n.language);
        document.body.classList.remove('rtl', 'ltr');
        document.body.classList.add(currentDir);

        // Listen for language changes
        const handleLanguageChange = (lng) => {
            const newDir = ['ar', 'ku'].includes(lng) ? 'rtl' : 'ltr';
            setDirection(newDir);
            setCurrentLanguage(lng);
            document.documentElement.setAttribute('dir', newDir);
            document.documentElement.setAttribute('lang', lng);
            document.body.classList.remove('rtl', 'ltr');
            document.body.classList.add(newDir);
        };

        i18n.on('languageChanged', handleLanguageChange);

        return () => {
            i18n.off('languageChanged', handleLanguageChange);
        };
    }, [i18n]);

    const antdLocale = useMemo(() => {
        switch (currentLanguage) {
            case 'ar':
            case 'ku':
                return arEG;
            case 'en':
            default:
                return enUS;
        }
    }, [currentLanguage]);

    return (
        <ConfigProvider
            locale={antdLocale}
            direction={direction}
            theme={{
                token: {
                    colorPrimary: '#1890ff',
                    borderRadius: 6,
                },
            }}
        >
            {children}
        </ConfigProvider>
    );
};

export default LocaleProvider;
